import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { fadeInOut, INavbarData } from './helper';

@Component({
  selector: 'app-sublevel-menu',
  template: `
    <ul
      *ngIf="!collapsed && data.items && data.items.length > 0"
      class="sublevel-nav"
      [@submenu]="
        expanded
          ? {
              value: 'visible',
              params: { transitionParams: '400ms cubic-bezier(0.86, 0, 0.07, 1)', height: '*' }
            }
          : {
              value: 'hidden',
              params: { transitionParams: '400ms cubic-bezier(0.86, 0, 0.07, 1)', height: '0' }
            }
      "
    >
      <ng-container *ngFor="let item of data.items">
        <li *ngIf="item.visible !== false" class="sublevel-nav-item">
          <a
            class="sublevel-nav-link"
            (click)="handleClick(item)"
            *ngIf="item.items && item.items.length > 0"
            [ngClass]="{ 'active-sublevel': item.expanded }"
          >
            <span class="sublevel-link-text pl-4" @fadeInOut *ngIf="!collapsed">{{
              item.label
            }}</span>

            <lucide-icon
              *ngIf="!collapsed"
              class="menu-collapse-icon ml-auto"
              [name]="!item.expanded ? 'chevron-down' : 'chevron-up'"
            ></lucide-icon>
          </a>

          <span
            class="sublevel-nav-link sublevel-nav-link--disabled"
            *ngIf="item.disabled && (!item.items || item.items.length === 0)"
            aria-disabled="true"
            [attr.title]="item.disabledReason || null"
          >
            <span class="sublevel-link-text pl-4" @fadeInOut *ngIf="!collapsed">{{
              item.label
            }}</span>
          </span>

          <a
            class="sublevel-nav-link"
            *ngIf="!item.disabled && (!item.items || item.items.length === 0)"
            [routerLink]="[item.routeLink]"
            routerLinkActive="active-sublevel"
            [routerLinkActiveOptions]="{ exact: true }"
            (click)="handleClick(item)"
          >
            <span class="sublevel-link-text pl-4" @fadeInOut *ngIf="!collapsed">{{
              item.label
            }}</span>
          </a>

          <div *ngIf="item.items && item.items.length > 0">
            <app-sublevel-menu
              [data]="item"
              [collapsed]="collapsed"
              [multiple]="multiple"
              [expanded]="item.expanded"
            ></app-sublevel-menu>
          </div>
        </li>
      </ng-container>
    </ul>
  `,
  styleUrls: ['./sidebar.component.scss'],
  animations: [
    fadeInOut,
    trigger('submenu', [
      state('hidden', style({ height: '0', overflow: 'hidden' })),
      state('visible', style({ height: '*' })),
      transition('visible <=> hidden', [
        style({ overflow: 'hidden' }),
        animate('{{transitionParams}}'),
      ]),
      transition('void => *', animate(0)),
    ]),
  ],
})
export class SublevelMenuComponent {
  @Input() data: INavbarData = {
    routeLink: '',
    icon: '',
    label: '',
    items: [],
  };
  @Input() collapsed = false;
  @Input() animating: boolean | undefined;
  @Input() expanded: boolean | undefined;
  @Input() multiple: boolean = false;

  constructor(public router: Router) {}

  handleClick(item: any): void {
    if (!this.multiple) {
      if (this.data.items && this.data.items.length > 0) {
        for (let modelItem of this.data.items) {
          if (item !== modelItem && modelItem.expanded) {
            modelItem.expanded = false;
          }
        }
      }
    }
    item.expanded = !item.expanded;
  }

  getActiveClass(item: INavbarData): string {
    return item.expanded && this.router.url.includes(item.routeLink!) ? 'active-sublevel' : '';
  }
}
